/* eslint-disable @typescript-eslint/no-explicit-any */
import { getHttpClient } from 'src/http-client';

const apiUrl = process.env.REACT_APP_FIREBASE_FUNCTIONS_URL as string;

export type AutoamtionStatusType = 'enabled' | 'disabled'

export interface CreateAutomationData {
  name: string;
  organizationName: string;
  organizationId: string;
  status: AutoamtionStatusType;
  trigger: {
    type?: string;
    data: any;
  };
  conditions: Array<{
    type?: string;
    data?: any;
  }>;
  actions: Array<{
    type?: string;
    data?: any;
  }>
  projectId: string;
}

export async function createNewAutomationRuleService(data: CreateAutomationData) {
	const httpClient = getHttpClient();
	const response = await httpClient.post(`${apiUrl}/create-automation-rule/${data.organizationName}/${data.projectId}`,
		data,
		{
			headers: {
				'Content-Type': 'application/json'
			}
		}
	);

	if (response.status !== 200) {
		throw new Error('Failed to create automation rule.');
	}
  
	return response;
}